<template>
    <va-edit-layout>
        <supplier-types-form
            :id="id"
            :title="title"
            :item="item"
        ></supplier-types-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"]
};
</script>
